import { apiClient } from './client';

export interface LogisticsRequest {
  id: number; request_reference: string; request_type: string; requester_employee_id: number; department_id: number | null;
  duty_station: string | null; programme_id: number | null; project_id: number | null; activity_id: number | null;
  required_date: string; required_until: string | null; delivery_location: string | null; purpose: string;
  business_justification: string | null; priority: string; estimated_cost: string | null; estimated_cost_currency: string | null;
  comments: string | null; status: string; cancelled_reason: string | null; created_by: number; created_at: string;
}

export interface LogisticsRequestItem { id: number; description: string; quantity: string; unit: string | null; estimated_unit_cost: string | null; notes: string | null; }

export interface LogisticsAssignment {
  id: number; resource_type: string; vehicle_id: number | null; employee_id: number | null; asset_id: number | null;
  vendor_name: string | null; description: string | null; assignment_date: string; expected_completion_date: string | null;
  instructions: string | null; status: string; notes: string | null; created_at: string;
}

export const logisticsRequestsApi = {
  list: (filters: { status?: string; requestType?: string } = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, v]) => v) as [string, string][]);
    return apiClient.get<{ data: LogisticsRequest[] }>(`/api/logistics-requests${params.toString() ? `?${params}` : ''}`);
  },
  get: (id: number) => apiClient.get<{ data: LogisticsRequest }>(`/api/logistics-requests/${id}`),
  create: (input: Record<string, unknown>) => apiClient.post<{ data: { id: number; requestReference: string } }>('/api/logistics-requests', input),
  submit: (id: number) => apiClient.post<{ data: { id: number; status: string } }>(`/api/logistics-requests/${id}/submit`, {}),
  decide: (id: number, decision: 'approved' | 'rejected', comment: string) =>
    apiClient.post<{ data: { id: number; status: string } }>(`/api/logistics-requests/${id}/decide`, { decision, comment }),
  returnForRedraft: (id: number, comment: string) => apiClient.post<{ data: { id: number; status: string } }>(`/api/logistics-requests/${id}/return-for-redraft`, { comment }),
  cancel: (id: number, reason: string) => apiClient.post<{ data: { id: number; status: string } }>(`/api/logistics-requests/${id}/cancel`, { reason }),

  listItems: (id: number) => apiClient.get<{ data: LogisticsRequestItem[] }>(`/api/logistics-requests/${id}/items`),
  addItem: (id: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/logistics-requests/${id}/items`, input),

  listAssignments: (id: number) => apiClient.get<{ data: LogisticsAssignment[] }>(`/api/logistics-requests/${id}/assignments`),
  createAssignment: (id: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/logistics-requests/${id}/assignments`, input),
  setAssignmentStatus: (assignmentId: number, status: string, notes?: string) =>
    apiClient.put<{ data: { id: number; status: string } }>(`/api/logistics-assignments/${assignmentId}/status`, { status, notes }),
};
